export const setAuthInfo = authInfo => ({
  type: 'SET_AUTH_INFO',
  authInfo
});
